// @ts-nocheck
import { createApp } from 'vue/dist/vue.esm-bundler';
import TurbolinksAdapter from 'vue-turbolinks';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import ru from '../../frontend/locales/ru.json';
import en from '../../frontend/locales/en.json';

const messages = {
  ru,
  en
};

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: document.querySelector('meta[name="current-locale"]')?.content || 'ru',
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true
});

import axios from 'axios';
import { initVueSentry } from '../sentry';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css';

// Import ActionCable channels
import '../channels';

import ImageFallBack from "../../frontend/directives/ImgFallback";
import GlobalNotifications from '../../frontend/components/shared/GlobalNotifications.vue';

import Modal from '../../frontend/components/modal/Modal.vue';
import VContent from '../../frontend/components/modal/VContent.vue';
import VTitle from '../../frontend/components/modal/VTitle.vue';
import CardModal from '../../frontend/components/modal/CardModal.vue';
import UnitModal from '../../frontend/components/modal/UnitModal.vue';
import RedeemModal from '../../frontend/components/modal/RedeemModal.vue';

import CurrentBuild from '../../frontend/components/roster/display/CurrentBuild.vue';
import RosterName from '../../frontend/components/roster/display/RosterName.vue';
import RosterFormat from '../../frontend/components/roster/display/RosterFormat.vue';
import ShareButton from '../../frontend/components/roster/display/ShareButton.vue';
import RedeemButton from '../../frontend/components/roster/display/RedeemButton.vue';
import CurrentUnits from '../../frontend/components/roster/display/CurrentUnits.vue';

// import SelectName from '../../frontend/components/roster/builder/SelectName.vue';
// import SelectFormat from '../../frontend/components/roster/builder/SelectFormat.vue';
import SelectDomain from '../../frontend/components/roster/builder/SelectDomain.vue';
import SelectFaction from '../../frontend/components/roster/builder/SelectFaction.vue';
import Breadcrumbs from '../../frontend/components/roster/display/Breadcrumbs.vue';
import SelectHero from '../../frontend/components/roster/builder/SelectHero.vue';
import SelectUnit from '../../frontend/components/roster/builder/SelectUnit.vue';
import Unit from '../../frontend/components/roster/builder/Unit.vue';
import SelectSpell from '../../frontend/components/roster/builder/SelectSpell.vue';
import SelectEquipment from '../../frontend/components/roster/builder/SelectEquipment.vue';
import SelectStructure from '../../frontend/components/roster/builder/SelectStructure.vue';

// Track the current app instance
let currentApp = null;

// Function to create and mount the roster app
const mountRosterApp = () => {
  const rosterContainer = document.getElementById('roster');

  if (!rosterContainer) {
    return;
  }

  // If there's already an app mounted, unmount it first
  if (currentApp) {
    currentApp.unmount();
    currentApp = null;
  }

  // Create new app with proper template
  const app = createApp({
    template: `
      <div>
        <global-notifications />
        <select-structure
          :roster="roster"
          :structure="structure"
        />

      </div>
    `,
    data() {
      return {
        // DISABLED: draft restore on locale switch — may re-enable later
        // presaved_roster: localStorage.getItem('roster') ? JSON.parse(localStorage.getItem('roster')) : false,
        // presaved_structure: localStorage.getItem('structure') ? JSON.parse(localStorage.getItem('structure')) : false,
        roster: gon.roster,
        structure: gon.roster.structure,
        pending_structure: gon.roster.structure.hero ? {...gon.roster.structure} : null,
      }
    },
    methods: {
      updateHero(hero) {
        if(this.pending_structure?.hero?.tech_name == hero?.tech_name) {
          this.structure = { ...this.pending_structure };
        } else{
          // save structure for "previous" hero selection case
          if(!this.pending_structure) {
            this.pending_structure = { ...this.structure };
          }

          this.structure.units = [];
          this.structure.spells = [];
          this.structure.equipment = [];
          this.structure.hero = hero;
          this.structure.point_cost = hero ? hero.point_cost : 0;
        }
      },
      changeLocale(locale) {
        this.$i18n.locale = locale;
      },
    },
    beforeMount() {
      document.addEventListener('turbolinks:load', () => {
        axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      });
    },
    errorCaptured(err, vm, info) {
      console.error('Vue error captured:', err, vm, info);
      return false;
    }
  })

  // Global properties
  app.config.globalProperties.$axios = axios;
  app.config.globalProperties.$toast = createToast;

  // Use plugins
  const pinia = createPinia();
  app.use(pinia);
  app.use(i18n);
  app.use(TurbolinksAdapter);

  initVueSentry({ app, appName: 'roster' });

  app.component('VueFinalModal', VueFinalModal);
  app.component('ModalsContainer', ModalsContainer);
  app.component('Modal', Modal);
  app.component('CardModal', CardModal);
  app.component('UnitModal', UnitModal);
  app.component('RedeemModal', RedeemModal);
  app.component('VContent', VContent);
  app.component('VTitle', VTitle);

  app.component('CurrentBuild', CurrentBuild);
  app.component('RosterName', RosterName);
  app.component('RosterFormat', RosterFormat);
  app.component('ShareButton', ShareButton);
  app.component('RedeemButton', RedeemButton);
  app.component('CurrentUnits', CurrentUnits);
  app.component('Breadcrumbs', Breadcrumbs);

  app.component('SelectFaction', SelectFaction);
  app.component('SelectDomain', SelectDomain);
  app.component('SelectHero', SelectHero);
  app.component('SelectUnit', SelectUnit);
  app.component('Unit', Unit);
  app.component('SelectSpell', SelectSpell);
  app.component('SelectEquipment', SelectEquipment);
  app.component('SelectStructure', SelectStructure);

  // Register global notifications component
  app.component('GlobalNotifications', GlobalNotifications);

  app.directive("image-fallback", ImageFallBack);

  // Mount the app
  currentApp = app;
  app.mount('#roster');
  // DISABLED: Locale switching — save/restore roster draft across locale change (may re-enable later)
  // const bindLocaleToggleLinks = () => {
  //   const localeToggleLinks = document.querySelectorAll<HTMLAnchorElement>('.locale-toggle a[href]');
  //   localeToggleLinks.forEach((link) => {
  //     if (link.dataset.localeSwitchBound === '1') return;
  //     link.dataset.localeSwitchBound = '1';
  //
  //     link.addEventListener('click', () => {
  //       if (!document.getElementById('roster')) return;
  //       try {
  //         sessionStorage.setItem('roster_draft_restore_once', '1');
  //       } catch (_) {}
  //       // do NOT prevent default — let Rails reload the page
  //     });
  //   });
  // };
  //
  // bindLocaleToggleLinks();
};

// Initialize roster app when DOM is ready
document.addEventListener('DOMContentLoaded', mountRosterApp);
// Support Turbolinks navigation (DOMContentLoaded won't fire)
document.addEventListener('turbolinks:load', mountRosterApp);
